import {Filter} from '@github-ui/filter'
import type {FilterQuery} from '@github-ui/filter-core'
import {useFilterProviders} from '@github-ui/shared-filter-providers/providers/use-filter-providers'
import {Button} from '@primer/react'
import {useCallback, useState} from 'react'

import {LABELS} from '../../constants/labels'
import styles from './SavedViewFilterBar.module.css'

interface SavedViewFilterBarProps {
  owner: string
  repo: string
  /** The saved view's stored query — used to detect dirty state. */
  savedQuery: string
  /** The currently active query (URL or stored). */
  currentQuery: string
  /** Push a new query to the URL (and the live preview). */
  onQueryChange: (query: string) => void
}

export function SavedViewFilterBar({owner, repo, savedQuery, currentQuery, onQueryChange}: SavedViewFilterBarProps) {
  const [filterValue, setFilterValue] = useState(currentQuery)
  const [syncedQuery, setSyncedQuery] = useState(currentQuery)
  if (syncedQuery !== currentQuery) {
    setSyncedQuery(currentQuery)
    setFilterValue(currentQuery)
  }

  const filterProviders = useFilterProviders({
    repositoryScope: `${owner}/${repo}`,
    isOrgScope: true,
    isIssueFieldsEnabled: true,
  })

  const handleSubmit = useCallback((request: FilterQuery) => onQueryChange(request.raw), [onQueryChange])

  const isDirty = currentQuery.trim() !== savedQuery.trim()

  return (
    <div className={styles.filterRow}>
      <div className={styles.filterField}>
        <Filter
          id="saved-view-filter"
          label={LABELS.issueSearchInputAriaLabel}
          placeholder={LABELS.issueSearchInputPlaceholder}
          variant="input"
          providers={filterProviders}
          filterValue={filterValue}
          onChange={setFilterValue}
          onSubmit={handleSubmit}
          settings={{groupAndKeywordSupport: true}}
          showValidationMessage={false}
          visuallyHideLabel
        />
      </div>
      <Button type="button" variant={isDirty ? 'primary' : 'default'} disabled={!isDirty}>
        {/* TODO: wire up save mutation */}
        Save
      </Button>
    </div>
  )
}
